module.exports = __webpack_public_path__ + "static/media/information-symbol.2a46e9b9.svg";